import { render, staticRenderFns } from "./PolicyHistory.vue?vue&type=template&id=3df22c7c&"
import script from "./PolicyHistory.vue?vue&type=script&lang=js&"
export * from "./PolicyHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports